import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FestiveService } from '../../../../services/festive.service';

let nextId = 0;

/** Small seasonal illustration shown beside the logo; renders nothing outside a festival. */
@Component({
  selector: 'app-festive-doodle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './festive-doodle.component.html',
  styleUrls: ['./festive-doodle.component.scss'],
})
export class FestiveDoodleComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  // Gradient ids must be unique per instance or a hidden copy breaks the visible one
  readonly uid = `fd${nextId++}`;

  constructor(public festiveService: FestiveService) {}

  url(name: string): string {
    return `url(#${this.uid}-${name})`;
  }
}
